import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

const TRANSITION_MS = 250;

export const useNotificationTileStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    boxShadow: tokens.shadow2,
    borderRadius: tokens.borderRadiusMedium,
    overflow: 'hidden',
    maxHeight: '50rem',
    opacity: 1,
    transitionProperty: 'max-height, opacity, margin, padding',
    transitionDuration: `${TRANSITION_MS}ms`,
    transitionTimingFunction: tokens.curveEasyEase,
  },
  exiting: {
    maxHeight: '0',
    opacity: 0,
    marginBlock: '0',
    paddingBlock: '0',
  },
  severityBar: {
    width: '0.25rem',
    flexShrink: 0,
  },
  severitySuccess: {
    backgroundColor: tokens.colorPaletteGreenBackground3,
  },
  severityError: {
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
  severityWarning: {
    backgroundColor: tokens.colorPaletteYellowBackground3,
  },
  severityInfo: {
    backgroundColor: tokens.colorBrandBackground,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
    flexGrow: 1,
    minWidth: 0,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
  },
  message: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  timestamp: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
  },
  closeButton: {
    alignSelf: 'flex-start',
    color: tokens.colorNeutralForeground3,
    minWidth: 'auto',
  },
});

export const NOTIFICATION_TILE_TRANSITION_MS = TRANSITION_MS;
